import { render } from "./MGUserView.vue?vue&type=template&id=74eb0fc8&scoped=true"
import script from "./MGUserView.vue?vue&type=script&lang=js"
export * from "./MGUserView.vue?vue&type=script&lang=js"

import "./MGUserView.vue?vue&type=style&index=0&id=74eb0fc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74eb0fc8"]])

export default __exports__